/**
 * Resolves the logged in service provider ID by first checking the current URL's
 * `serviceProviderId` query param (present on the initial login redirect), then
 * falling back to the value persisted in sessionStorage for subsequent page loads.
 *
 * @param href - The full URL string to inspect (typically `window.location.href`).
 * @param sessionStorageValue - The value currently stored under the
 *   `serviceProviderId` sessionStorage key (may be `null` if not yet set).
 * @returns The resolved service provider ID, or `null` if neither source has a value.
 */
export function resolveServiceProviderId({
  href,
  sessionStorageValue,
}: {
  href?: string;
  sessionStorageValue?: string | null;
} = {}): string | null {
  const urlParam = href ? new URL(href).searchParams.get('serviceProviderId') : null;
  return urlParam ?? sessionStorageValue ?? null;
}
